<template>
  <!-- 每周监测 -->
  <div class="paginations" :style="{filter: this.$store.state.isVague?'blur(2px)':''}">
    <div class="table-search-box">
      <el-form :inline="true" :model="searchData" class="demo-form-inline">
        <!-- 防止输入框回车刷新页面 -->
        <el-form-item label="" v-show="false">
          <el-input></el-input>
        </el-form-item>
        <!-- <el-form-item label="资源库：">
          <el-input size="small" v-model="searchData.zykname" placeholder="请输入资源库"></el-input>
        </el-form-item> -->
        <el-form-item label="月份：">
          <el-date-picker size="small" type="month" placeholder="选择日期" v-model="searchData.yearMonth" :clearable='false' value-format="yyyy-MM" popper-class="dateClass"></el-date-picker>
        </el-form-item>
        <el-form-item label="周期：">
          <el-select size="small" v-model="searchData.week" placeholder="请选择" filterable :popper-append-to-body="false">
            <el-option v-for="(item,index) in dropDown.weekList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台：">
          <el-select size="small" v-model="searchData.platformid" placeholder="请选择" filterable :popper-append-to-body="false">
            <el-option v-for="(item,index) in dropDown.platformList" :key="index" :label="item.platformname" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理状态：">
          <el-select size="small" v-model="searchData.status" placeholder="请选择" filterable :popper-append-to-body="false">
            <el-option v-for="(item,index) in dropDown.statusList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="search_button">
            <i class="pointer el-icon-search" @click="search('1')"></i>
            <i class="pointer el-icon-refresh-left" @click="reset"></i>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="table_box">
      <el-table :data="tableObj.list" style="width: 100%">
        <el-table-column type="index" label="序号" align='center'></el-table-column>
        <el-table-column prop="yearMonth" label="年月" align='center'></el-table-column>
        <el-table-column prop="week" label="周期" align='center'></el-table-column>
        <el-table-column prop="platformName" label="平台" align='center'></el-table-column>
        <el-table-column prop="totalCount" label="总数据量" align='center'></el-table-column>
        <el-table-column prop="insertCount" label="新增数量" align='center'></el-table-column>
        <el-table-column prop="updateCount" label="更新数量" align='center'></el-table-column>
        <el-table-column prop="failedCount" label="失败数量" align='center'></el-table-column>
        <el-table-column label="创建日期" align='center'>
          <template slot-scope="scope">
            <span>{{scope.row.createTime?scope.row.createTime.substring(0,10):''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="预计处理日期" align='center'>
          <template slot-scope="scope">
            <span>{{scope.row.startTime?scope.row.startTime.substring(0,10):''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否处理" align='center'>
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">未处理</span>
            <span v-if="scope.row.status == 2" style="color: #1AECEF;">已处理</span>
            <el-tooltip class="item" effect="dark" content="已逾期" placement="top-start">
              <el-badge v-if="scope.row.status == 3" is-dot class="item">未处理</el-badge>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" align='center'>
          <template slot-scope="scope">
            <i class="icona icon-download" title="下载" @click="download(scope.row.fileid)"></i>
          </template>
        </el-table-column>
      </el-table>
      <pageNumber :paginations="7" :pageNum="searchData.pageDto.pageNum" :pageSize="searchData.pageDto.pageSize" :total="tableObj.total" :jumpTo="tableObj.jumpTo" @currentChange="search"></pageNumber>
    </div>
  </div>
</template>

<script>

import pageNumber from '@/components/pageNumber.vue' //分页

export default {
  components: {
    pageNumber
  },
  data() {
    return {
      headers: { "lrmv2token": sessionStorage.getItem('lrmv2token') },
      searchData: {
        zykname: '',
        yearMonth: '',
        week: '',
        platformid: '',
        status: '',
        pageDto: {
          pageNum: 1,//当前显示的页面页码数
          pageSize: 10,
        }
      },

      tableObj: {
        total: 0,
        jumpTo: 1,
        list: []
      },

      dropDown: {   //下拉框
        weekList: [{ id: 1, name: '1' }, { id: 2, name: '2' }, { id: 3, name: '3' }, { id: 4, name: '4' }],
        platformList: [],
        statusList: [{ id: 1, name: '未处理' }, { id: 2, name: '已处理' }],
      }
    }
  },
  created() {
    this.platformsDom()
    this.search()
  },
  methods: {
    // 获取所有平台下拉选项
    platformsDom() {
      this.$axios.post(this.$apiurls.task_getAllPlatforms, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.dropDown.platformList = res.data
        }
      })
    },

    // 查询表格数据
    search(type) {
      this.searchData.pageDto.pageNum = type ? type : 1
      this.tableObj.jumpTo = type ? type : 1
      this.$axios.post(this.$apiurls.task_getLv2PlatformWeekMonitorEntityList, this.searchData, {
        loading: false,
      }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.list.length; i++) {
            var data1 = new Date(res.data.list[i].deadline)
            var data2 = new Date()
            if (data1.getTime() < data2.getTime() && res.data.list[i].status == 1) {
              res.data.list[i].status = 3
            } else if (data1.getTime() > data2.getTime() && res.data.list[i].status == 3) {
              res.data.list[i].status = 1
            }
          }
          if (type) {
            this.$message({
              message: '查询成功！',
              type: 'success'
            });
          }
          this.tableObj.list = res.data.list
          this.tableObj.total = res.data.total
        }
      });
    },
    // 重置表格
    reset() {
      this.searchData.zykname = ''
      this.searchData.yearMonth = ''
      this.searchData.week = ''
      this.searchData.platformid = ''
      this.searchData.status = ''
      this.search()
    },
    // 下载
    download(fileid) {
      if (fileid) {
        window.open(`${this.$apiurls.task_downloadLv2PlatformTaskFileInfo}?fileid=${fileid}`)
      } else {
        this.$message.error('下载失败，没有上传文件')
      }
    },
  }
}
</script>


<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/tableList.scss" scoped></style>
